<template>
    <div id="populate-popup-container" class="modal">
        <div class="popup-body" :class="{ 'loading-state': isLoading }">
            <div class="populate-popup-header">
                <span class="popup-title">Populate</span>
                <i class="fas fa-times" @click="onCloseClicked"></i>
            </div>
            <div v-if="!isLoading" class="populate-properties">
                <div class="properties-header">
                    <span>Tag Property</span>
                    <span class="model-properties">3D Model Property</span>
                </div>
                <div class="populate-property" v-for="property in properties" :key="property.name">
                    <PopulatePropertyRow :key="property.name" 
                        :property="property"
                        @link_property="updatedMappedProperty" 
                        @update_value="updateProperty" 
                        :options="property.name === 'Category'? categoriesOptions : options"
                        @mode_changed="onModeChanged(property)">
                    </PopulatePropertyRow>
                </div>
            </div>
            <LoadingPopup else :show="isLoading" :text="progressText" style="position: relative;"></LoadingPopup>

            <div class="popup-footer" v-if="!isLoading">
                <div class="popup-actions">
                    <div class="popup-btn popup-btn-secondary" @click="onCloseClicked"> Cancel </div>
                    <div class="popup-btn popup-btn-primary" @click="populate()"> Generate </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { postDataAsync } from '@/utils/mongoUtils';
import { getDbIdsProperties, getNodePropertyByName } from '@/utils/forgeUtils';
export default {
    name: 'PopulateAutomaticTagsPopup',
    components: {
        PopulatePropertyRow: () => import('./populatePropertyRow.vue'),
        LoadingPopup: () => import('@/components/common/loadingPopup.vue'),
    },
    data() {
        return {
            progressText: 'Please wait...',
            showProgress: false,
            dbIDs: [],
            properties: [
                { name: 'Class', property: 'class', mappedProperty: '', value: '' },
                { name: 'Category', property: 'category', mappedProperty: '', value: '' },
                { name: 'WO No.', property: 'woNo', mappedProperty: '', value: '' },
                { name: 'MCDR No.', property: 'mcdrNo', mappedProperty: '', value: '' },
                { name: 'System', property: 'system', mappedProperty: '', value: '' },
                { name: 'Description', property: 'description', mappedProperty: '', value: '' },
                { name: 'Vendor', property: 'vendor', mappedProperty: '', value: '' },
                { name: 'P&ID', property: 'p_Id', mappedProperty: '', value: '' },
                { name: 'Work Pack No.', property: 'workPackNumber', mappedProperty: '', value: '' },
                { name: 'Item', property: 'equipmentItem', mappedProperty: '', value: '' },
                { name: 'Rating', property: 'rating', mappedProperty: '', value: '' },
                { name: 'MOC No.', property: 'mOCNo', mappedProperty: '', value: '' },
                { name: 'Vendor No.', property: 'vendorNo', mappedProperty: '', value: '' },
            ],
            options: []
        }
    },
    mounted() {
        this.showProgress = true;
        if (this.isViewerLoaded) {
            console.log("Load Now");
            this.getOptions();
        }
    },
    methods: {
        onCloseClicked() {
            this.$store.commit('SET_SHOW_POPULATE_AUTOMATIC_TAGS_POPUP', false);
        },
        updatedMappedProperty(value, property) {
            property.mappedProperty = value;
            property.value = '';
        },
        updateProperty(value, property) {
            property.mappedProperty = '';
            property.value = value;
        },
        getOptions() {
            this.showProgress = true;
            postDataAsync(`api/equipments/getGroupAutomaticTagsDbIds?assetId=${this.assetId}&harvesterId=${this.harvesterId}`, {}, data => {
                this.dbIDs = data;
                getDbIdsProperties(this.viewer, this.dbIDs).then(data => {
                    let values = new Set(data.map(p => p.displayName))
                    this.options = [...values.map(property => {
                        return { name: property, isChecked: false }
                    })]
                    this.showProgress = false;
                })
            });
        },
        checkCategory() {
            return new Promise((resolve, reject) => {
                this.showProgress = true;
                let category = this.properties.find(t => t.name === 'Category');
                if (!category.mappedProperty) resolve();
                let id = this.$store.state.categories.find(c => c.name === category.mappedProperty)?.id;
                category.value = id;
                category.mappedProperty = '';
                resolve();
            })
        },
        fillTagsWithValues() {
            return new Promise((resolve, reject) => {
                let filteredProperties = this.properties.filter(p => !!p.mappedProperty || !!p.value);

                let resultObject = {};
                let totalCounter = 0;

                for (let i = 0; i < this.dbIDs.length; i++) {
                    const nodeId = this.dbIDs[i];

                    let tag = this.$store.state.TAGS.allExistingAutomaticDbids.find(t => t.dbid == nodeId);

                    if (!tag) continue;

                    resultObject[tag.id] = {
                        id: tag.id,
                    }

                    for (let j = 0; j < filteredProperties.length; j++) {
                        const property = filteredProperties[j];

                        if (property.value) {
                            resultObject[tag.id][property.property] = property.value;

                            if (i === this.dbIDs.length - 1 && j === filteredProperties.length - 1 && !totalCounter) {
                                resolve(resultObject);
                            }
                        } else {
                            totalCounter++;

                            getNodePropertyByName(this.viewer, nodeId, property.mappedProperty).then(itemProperty => {
                                totalCounter--;

                                if (property.name === 'P&ID') {
                                    let accepted = this.p_Ids.any(p => p.name === (itemProperty?.displayValue ?? ''))

                                    if (accepted) resultObject[tag.id][property.property] = itemProperty?.displayValue ?? '';
                                } else {
                                    resultObject[tag.id][property.property] = itemProperty?.displayValue ?? '';
                                }

                                if (i === this.dbIDs.length - 1 && !totalCounter) {
                                    resolve(resultObject);
                                }
                            });
                        }
                    }
                }
            })
        },
        updateTags(result) {
            return new Promise((resolve, reject) => {
                let tags = Object.values(result);
                postDataAsync(`api/equipments/populateAutomaticTagsInformation`, tags, response => {
                    this.onCloseClicked();
                    this.showProgress = false;
                    this.$store.dispatch('showSuccessfulMessage', {
                        message: "Properties saved successfully.", timeout: 3000
                    })
                    resolve();
                });
            })
        },
        populate() {
            this.checkCategory().then(this.fillTagsWithValues).then(this.updateTags);
        },
        onModeChanged(property) {
            property.mappedProperty = '';
            property.value = '';
        }
    },
    computed: {
        isViewerLoaded() {
            return this.$store.getters['getIsTreeLoaded']
        },
        isLoading() {
            return !this.isViewerLoaded || this.showProgress;
        },
        harvesterId() {
            return this.$store.getters['GET_POPULATE_AUTOMATIC_TAGS_GROUP'];
        },
        categoriesOptions() {
            return this.$store.state.categories.map(c => {
                return { name: c.name, isChecked: false }
            });
        },
        p_Ids() {
            return this.$store.getters['GET_P_IDS'] ?? [];
        },
        assetId () {
            return this.$store.state.assetId;
        },
        viewer: {
            get() {
                return this.$store.state.viewer;
            }
        }
    },
    watch: {
        'isViewerLoaded' : {
            handler: function (newValue, oldValue) {
                if ((newValue !== oldValue) && newValue) { 
                    console.log("Load Now form Watch")
                    this.getOptions();
                }
            }
        }
    }
}
</script>
    
<style>
#populate-popup-container {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(1, 1, 1, .5);
}

#populate-popup-container .populate-popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#populate-popup-container .popup-title {
    color: var(--primary-color);
    font-size: 24px;
    font-weight: 600;
}

#populate-popup-container .populate-popup-header i {
    color: var(--light-primary-color);
    font-size: 18px;
    font-weight: bold;
}

#populate-popup-container .populate-popup-header i:hover,
#populate-popup-container .populate-popup-header i:focus,
.populate-properties .property-title i:hover {
    color: var(--primary-color);
    text-decoration: none;
    cursor: pointer;
}

#populate-popup-container .popup-body .populate-properties {
    padding: 20px 0px;
}

#populate-popup-container .popup-body {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: rgb(255, 255, 255);
    border: 1px solid #6c6c6c;
    height: fit-content;
    max-height: 100%;
    overflow: auto;
    width: 500px;
    padding: 20px;
    border-radius: 15px;
}

#populate-popup-container .popup-body.loading-state {
    width: 400px;
    left: calc(50% - 200px);
    top: calc(50% - 200px);
    border: 1px solid #F2F2F2;
}

#populate-popup-container .populate-properties .property-title {
    font-size: 14px;
    color: #6c6c6c;
    width: 40%;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-inline-end: 10px;
}

.populate-properties .property-value {
    width: 60%;
}

.populate-properties .property-input {
    height: 100%;
    font-size: 13px;
    font-weight: 600;
    border-color: var(--light-primary-color);
}

.populate-properties .property-input:focus, 
.populate-properties .property-input:hover {
    border-color: var(--primary-color);
}

.populate-properties > .populate-property {
    padding: 5px 0px;
    border-bottom: 1px solid var(--light-primary-color);
}

.populate-property .property-value {
    display: flex;
    column-gap: 5px;
}

.populate-property .property-value .popup-btn {
    font-size: 10px;
}

.populate-properties .select-box-container {
    padding: 5px;
}

#populate-popup-container .popup-actions {
    padding: 0;
}
 
#populate-popup-container .properties-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 3px solid var(--light-primary-color);
    padding-bottom: 10px;
    font-size: 16px;
    font-weight: 700;
    color: var(--light-primary-color);
}

#populate-popup-container .properties-header .model-properties {
    width: 70%;
    display: flex;
    justify-content: center;
}

#populate-popup-container .popup-btn-primary.disabled {
    background: #f2f2f2;
    color: #b3b3b3;
    pointer-events: none;
}
</style>
    